<template>
  <div>
    <div class="loading" v-if="loading">
      Loading...
    </div>

    <div v-if="error" class="error">
      {{ error }}
    </div>
    
    <ul class="scene-list">
      <li v-for="scene in scenes" class="list__item" :key="scene._id">
        <div class="scene-tile">
          <router-link class="scene-tile__image-link" :to="{name: 'scene', params: {id: scene._id}}">
            <div class="scene-tile__preview-container">
              <img class="thumbnail" v-if="scene.thumbnail" :src="imageUrlFor(scene.thumbnail).ignoreImageParams().width(480)"/>
              <img class="screens" v-if="scene.screencaps" :src="imageUrlFor(scene.screencaps).ignoreImageParams()"/>
            </div>
          </router-link>
          <router-link class="scene-tile__name" :to="{name: 'scene', params: {id: scene._id}}">
            <span>{{scene.name}}<div v-if="scene.favorite" class="scene-tile__favorite"></div></span>
            <div class="scene-tile__date">{{new Date(scene.release).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"})}}</div>
          </router-link>

          <h3 class="scene-tile__title">
            <div class="scene-tile__meta-wrapper">
              <div class="scene-tile__studio-wrapper">
                <ul class="scene-tile__studios" v-if="scene.studios" >
                  <li class="scene-tile__studio" v-for="studio in scene.studios" :style="{ 'border-color': studio.color, 'background-color': studio.color + '0d' }">
                    <router-link :to="{name: 'studio', params: {id: studio._id}}" >
                      <div class="scene-tile__studio-name">{{studio.name}}</div>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="scene-tile__details">
                <ul v-if="scene.models" class="scene-tile__models">
                  <li class="scene-tile__model" v-for="model in scene.models">
                    <router-link class="scenes__model-link" :to="{name: 'model', params: {id: model._id}}">
                      <div class="scene-tile__model-image"
                        v-bind:style="[{ backgroundImage: `url(${imageUrlFor(model.imageHeadshot)})`}]">
                      </div>
                      <div class="scene-tile__model-name">
                        {{model.name}}
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </h3>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
const imageBuilder = imageUrlBuilder(sanity);
const query = `*[_type == "scene" && name match $alias] {
  _id,
  name,
  path,
  release,
  models,
  studios,
  thumbnail,
  screencaps,
  models[]->,
  studios[]->,
  favorite
}[0...50]`;

export default {
  props: {
    alias: {
      type: String
    }
  },
  name: "Aliases",
  data() {
    return {
      loading: true,
      scenes: []
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    },
    fetchData() {
      this.error = this.post = null;
      this.loading = true;
      sanity.fetch(query, { alias: this.alias }).then(
        scenes => {
          this.loading = false;
          this.scenes = scenes;
        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>

<style scoped>

</style>
